import PinImageCSS from 'app/common/react/components/growth/unauth/pin/PinImage/PinImageCSS';

const PinCreditCSS = () => `
.PinCredit__image:after {
  border-radius: 50%;
  -webkit-box-shadow: 0 0 2px rgba(0,0,0,0.33) inset;
  box-shadow: 0 0 2px rgba(0,0,0,0.33) inset;
  content: ' ';
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 30px;}
`;

export default function cssStyles(pageType, seoUnauthExperiments) {
  return PinImageCSS(pageType, seoUnauthExperiments) + PinCreditCSS();
}
